import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d1af9aaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-subtitle-1 font-weight-bold mb-1" }, "Evolución del ELO", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-subtitle-1 font-weight-bold mt-4 mb-1" }, "Balance", -1))
const _hoisted_4 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-subtitle-1 font-weight-bold mt-4 mb-1" }, "Ejércitos más jugados", -1))
const _hoisted_6 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis"
}
const _hoisted_7 = ["onClick", "onKeydown"]
const _hoisted_8 = { class: "flex-grow-1 min-w-0" }
const _hoisted_9 = { class: "text-body-2 font-weight-bold text-wrap" }
const _hoisted_10 = { class: "text-caption text-medium-emphasis" }
const _hoisted_11 = { class: "text-body-2 font-weight-bold" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-subtitle-1 font-weight-bold mt-4 mb-1" }, "Rivales más habituales", -1))
const _hoisted_13 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis"
}
const _hoisted_14 = ["onClick", "onKeydown"]
const _hoisted_15 = { class: "flex-grow-1 min-w-0" }
const _hoisted_16 = { class: "text-body-2 font-weight-bold text-wrap" }
const _hoisted_17 = { class: "text-caption text-medium-emphasis" }
const _hoisted_18 = { class: "text-body-2 font-weight-bold" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-subtitle-1 font-weight-bold mt-4 mb-1" }, "Mejores resultados", -1))
const _hoisted_20 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis mb-0"
}
const _hoisted_21 = { class: "text-body-2 flex-grow-1 text-wrap" }
const _hoisted_22 = { class: "text-body-2 font-weight-bold text-no-wrap" }
const _hoisted_23 = { class: "text-subtitle-1 font-weight-bold mt-4 mb-1" }
const _hoisted_24 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis mb-0"
}
const _hoisted_25 = { class: "d-flex justify-space-around text-center mb-2" }
const _hoisted_26 = { class: "text-h6 text-success" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption" }, "Ganadas", -1))
const _hoisted_28 = { class: "text-h6 text-medium-emphasis" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption" }, "Empatadas", -1))
const _hoisted_30 = { class: "text-h6 text-error" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption" }, "Perdidas", -1))
const _hoisted_32 = { class: "d-flex align-center ga-2" }
const _hoisted_33 = { class: "text-body-2 font-weight-bold" }
const _hoisted_34 = { class: "text-caption text-medium-emphasis ms-auto text-no-wrap" }
const _hoisted_35 = { class: "text-caption text-medium-emphasis text-wrap" }
const _hoisted_36 = {
  key: 0,
  class: "text-caption text-wrap"
}

import { computed, ref, watch } from "vue";
import { UsuarioDataDTO } from "@/interfaces/Usuario";
import { appsettings } from "@/settings/appsettings";
import {
  balanceDe,
  FiltroPartidas,
  normalizarEjercito,
  PartidaJugada,
  ResultadoPartida,
  textoPosicion,
} from "@/utils/historialJugador";
import { colorBando, textoBando } from "@/utils/estadisticasEjercitos";
import SparklineElo from "@/components/Elo/SparklineElo.vue";
import BarraBalance from "@/components/DetalleJugador/BarraBalance.vue";

type Origen = "todas" | "torneo" | "amistosa";

export default /*#__PURE__*/_defineComponent({
  __name: 'ResumenJugador',
  props: {
    usuario: {},
    partidas: {},
    idUsuarioQueMira: {}
  },
  emits: ["filtrar"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;


// Qué partidas cuentan en los ejércitos y en el cara a cara: las de eventos, las amistosas o todas
const ORIGENES: { valor: Origen; titulo: string }[] = [
  { valor: "todas", titulo: "Todas" },
  { valor: "torneo", titulo: "Eventos" },
  { valor: "amistosa", titulo: "Amistosas" },
];
const origenEjercitos = ref<Origen>("todas");
const origenRivales = ref<Origen>("todas");
const origenCara = ref<Origen>("todas");
const deOrigen = (partidas: PartidaJugada[], origen: Origen) =>
  origen === "todas" ? partidas : partidas.filter(p => p.origen === origen);
const fecha = (valor: string) => new Date(valor).toLocaleDateString("es-ES");

const balanceTotal = computed(() => balanceDe(props.partidas));
const filasBalance = computed(() => [
  { titulo: "Total", balance: balanceTotal.value },
  { titulo: "Eventos", balance: balanceDe(props.partidas.filter(p => p.origen === "torneo")) },
  { titulo: "Amistosas", balance: balanceDe(props.partidas.filter(p => p.origen === "amistosa")) },
]);

const normalizar = normalizarEjercito;
const ejercitosApp = new Map(appsettings.armies.map(a => [normalizar(a.name), a]));

// Todos, del más jugado al menos; a igual número de partidas, el de más victorias
const ejercitos = computed(() => {
  const porEjercito = new Map<string, { nombre: string; partidas: PartidaJugada[] }>();
  deOrigen(props.partidas, origenEjercitos.value).forEach(p => {
    if (!p.ejercito) return;
    const clave = normalizar(p.ejercito);
    const grupo = porEjercito.get(clave) ?? {
      nombre: ejercitosApp.get(clave)?.name ?? p.ejercito,
      partidas: [],
    };
    grupo.partidas.push(p);
    porEjercito.set(clave, grupo);
  });
  return [...porEjercito.entries()]
    .map(([clave, { nombre, partidas }]) => ({
      nombre,
      bando: ejercitosApp.get(clave)?.band,
      balance: balanceDe(partidas),
      partidas,
    }))
    .sort((a, b) => b.balance.total - a.balance.total || b.balance.porcentaje - a.balance.porcentaje);
});

// Los rivales, del más habitual al menos; en Dobles cuentan los dos de la otra pareja
const rivales = computed(() => {
  const porRival = new Map<number, { nick: string; partidas: PartidaJugada[] }>();
  deOrigen(props.partidas, origenRivales.value).forEach(p =>
    p.idsRivales.forEach((id, i) => {
      const grupo = porRival.get(id) ?? { nick: p.nicksRivales[i] || "Sin nick", partidas: [] };
      grupo.partidas.push(p);
      porRival.set(id, grupo);
    })
  );
  return [...porRival.entries()]
    .map(([id, { nick, partidas }]) => ({ id, nick, balance: balanceDe(partidas), partidas }))
    .sort((a, b) => b.balance.total - a.balance.total || b.balance.porcentaje - a.balance.porcentaje);
});
const rivalesVisibles = computed(() =>
  verTodosRivales.value ? rivales.value : rivales.value.slice(0, 3)
);

// Con Todas elegido, a la pestaña donde tiene más de esas partidas
function verPartidas(filtro: FiltroPartidas, partidas: PartidaJugada[], origen: Origen) {
  const amistosas = partidas.filter(p => p.origen === "amistosa").length;
  const destino =
    origen !== "todas" ? origen : amistosas > partidas.length - amistosas ? "amistosa" : "torneo";
  emit("filtrar", filtro, destino);
}

// Los eventos con posición final, del mejor puesto al peor; a igual puesto, el más reciente primero
const resultados = computed(() =>
  [...(props.usuario.clasificacionTorneos ?? [])]
    .filter(r => r.resultado > 0)
    .sort((a, b) => a.resultado - b.resultado || (b.idTorneo ?? 0) - (a.idTorneo ?? 0))
);
const resultadosVisibles = computed(() =>
  verTodosResultados.value ? resultados.value : resultados.value.slice(0, 3)
);
const colorPuesto = (puesto: number) =>
  puesto === 1 ? "amber" : puesto === 2 ? "blue-grey-lighten-2" : puesto === 3 ? "brown-lighten-1" : "grey";

// Visto desde quien mira: las victorias del jugador son sus derrotas
const invertir = (resultado: ResultadoPartida): ResultadoPartida =>
  resultado === "V" ? "D" : resultado === "D" ? "V" : "E";
const caraACara = computed(() => {
  const id = props.idUsuarioQueMira;
  if (!id || id === props.usuario.idUsuario) return null;
  const entreLosDos = deOrigen(props.partidas, origenCara.value)
    .filter(p => p.idsRivales.includes(id))
    .map(p => ({ ...p, resultado: invertir(p.resultado) }));
  return {
    balance: balanceDe(entreLosDos),
    partidas: entreLosDos,
  };
});
// Los desplegables, cerrados al empezar y al pasar a otro jugador: la vista se reutiliza
const verPartidasCara = ref(false);
const verTodosResultados = ref(false);
const verTodosEjercitos = ref(false);
const verTodosRivales = ref(false);
watch(
  () => props.usuario.idUsuario,
  () => {
    verPartidasCara.value = false;
    verTodosResultados.value = false;
    verTodosEjercitos.value = false;
    verTodosRivales.value = false;
  }
);
const ejercitosVisibles = computed(() =>
  verTodosEjercitos.value ? ejercitos.value : ejercitos.value.slice(0, 3)
);
const colorResultado = (resultado: ResultadoPartida) =>
  resultado === "V" ? "success" : resultado === "D" ? "error" : "grey";

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(SparklineElo, {
      idUsuario: _ctx.usuario.idUsuario
    }, null, 8, ["idUsuario"]),
    _hoisted_3,
    _createVNode(_component_v_card, {
      class: "pa-3 mb-2",
      variant: "outlined"
    }, {
      default: _withCtx(() => [
        (balanceTotal.value.total === 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Aún no tiene partidas jugadas. "))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(filasBalance.value, (fila) => {
              return (_openBlock(), _createBlock(BarraBalance, {
                key: fila.titulo,
                titulo: fila.titulo,
                balance: fila.balance,
                class: "mb-3"
              }, null, 8, ["titulo", "balance"]))
            }), 128))
      ]),
      _: 1
    }),
    (_ctx.partidas.some(p => p.ejercito))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_5,
          _createVNode(_component_v_card, {
            class: "pa-3 mb-2",
            variant: "outlined"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_chip_group, {
                modelValue: origenEjercitos.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((origenEjercitos).value = $event)),
                mandatory: "",
                column: "",
                "selected-class": "text-primary",
                class: "mb-1"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ORIGENES, (o) => {
                    return _createVNode(_component_v_chip, {
                      key: o.valor,
                      value: o.valor,
                      size: "small",
                      filter: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(o.titulo), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (ejercitos.value.length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, " No tiene " + _toDisplayString(origenEjercitos.value === "torneo" ? "partidas de eventos" : "amistosas") + " con ejército. ", 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ejercitosVisibles.value, (ejercito) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: ejercito.nombre,
                  role: "button",
                  tabindex: "0",
                  class: "d-flex align-center ga-2 fila-pulsable",
                  onClick: ($event: any) => (verPartidas({ ejercito: ejercito.nombre }, ejercito.partidas, origenEjercitos.value)),
                  onKeydown: _withKeys(($event: any) => (verPartidas({ ejercito: ejercito.nombre }, ejercito.partidas, origenEjercitos.value)), ["enter"])
                }, [
                  _createVNode(_component_v_icon, {
                    size: "small",
                    icon: "mdi-shield",
                    color: _unref(colorBando)(ejercito.bando),
                    title: _unref(textoBando)(ejercito.bando)
                  }, null, 8, ["color", "title"]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(ejercito.nombre), 1),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(ejercito.balance.total) + " " + _toDisplayString(ejercito.balance.total === 1 ? "partida" : "partidas") + " · " + _toDisplayString(ejercito.balance.victorias) + "-" + _toDisplayString(ejercito.balance.empates) + "-" + _toDisplayString(ejercito.balance.derrotas), 1)
                  ]),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(ejercito.balance.porcentaje) + "%", 1),
                  _createVNode(_component_v_icon, {
                    size: "small",
                    icon: "mdi-chevron-right",
                    class: "text-medium-emphasis"
                  })
                ], 40, _hoisted_7)), [
                  [_directive_ripple]
                ])
              }), 128)),
              (ejercitos.value.length > 3)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 1,
                    variant: "text",
                    size: "small",
                    class: "px-0",
                    "append-icon": verTodosEjercitos.value ? 'mdi-chevron-up' : 'mdi-chevron-down',
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (verTodosEjercitos.value = !verTodosEjercitos.value))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(verTodosEjercitos.value
              ? "Ver solo los tres más jugados"
              : `Ver ${ejercitos.value.length - 3 === 1 ? "el otro" : `los otros ${ejercitos.value.length - 3}`}`), 1)
                    ]),
                    _: 1
                  }, 8, ["append-icon"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createVNode(_component_v_btn, {
                  to: `/estadisticas-ejercito?seccion=jugadores&jugador=${_ctx.usuario.idUsuario}`,
                  variant: "text",
                  size: "small",
                  color: "primary",
                  class: "px-0 text-none",
                  "append-icon": "mdi-chevron-right"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Sus estadísticas por ejército ")
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ]),
            _: 1
          })
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.partidas.length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_12,
          _createVNode(_component_v_card, {
            class: "pa-3 mb-2",
            variant: "outlined"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_chip_group, {
                modelValue: origenRivales.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((origenRivales).value = $event)),
                mandatory: "",
                column: "",
                "selected-class": "text-primary",
                class: "mb-1"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ORIGENES, (o) => {
                    return _createVNode(_component_v_chip, {
                      key: o.valor,
                      value: o.valor,
                      size: "small",
                      filter: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(o.titulo), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (rivales.value.length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, " No tiene " + _toDisplayString(origenRivales.value === "torneo" ? "partidas de eventos" : "amistosas") + ". ", 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rivalesVisibles.value, (rival) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: rival.id,
                  role: "button",
                  tabindex: "0",
                  class: "d-flex align-center ga-2 fila-pulsable",
                  onClick: ($event: any) => (verPartidas({ idRival: rival.id, nickRival: rival.nick }, rival.partidas, origenRivales.value)),
                  onKeydown: _withKeys(($event: any) => (verPartidas({ idRival: rival.id, nickRival: rival.nick }, rival.partidas, origenRivales.value)), ["enter"])
                }, [
                  _createVNode(_component_v_icon, {
                    size: "small",
                    icon: "mdi-account",
                    class: "text-medium-emphasis"
                  }),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(rival.nick), 1),
                    _createElementVNode("div", _hoisted_17, _toDisplayString(rival.balance.total) + " " + _toDisplayString(rival.balance.total === 1 ? "partida" : "partidas") + " · " + _toDisplayString(rival.balance.victorias) + "-" + _toDisplayString(rival.balance.empates) + "-" + _toDisplayString(rival.balance.derrotas), 1)
                  ]),
                  _createElementVNode("span", _hoisted_18, _toDisplayString(rival.balance.porcentaje) + "%", 1),
                  _createVNode(_component_v_icon, {
                    size: "small",
                    icon: "mdi-chevron-right",
                    class: "text-medium-emphasis"
                  })
                ], 40, _hoisted_14)), [
                  [_directive_ripple]
                ])
              }), 128)),
              (rivales.value.length > 3)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 1,
                    variant: "text",
                    size: "small",
                    class: "px-0",
                    "append-icon": verTodosRivales.value ? 'mdi-chevron-up' : 'mdi-chevron-down',
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (verTodosRivales.value = !verTodosRivales.value))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(verTodosRivales.value
              ? "Ver solo los tres más habituales"
              : `Ver ${rivales.value.length - 3 === 1 ? "el otro" : `los otros ${rivales.value.length - 3}`}`), 1)
                    ]),
                    _: 1
                  }, 8, ["append-icon"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 64))
      : _createCommentVNode("", true),
    _hoisted_19,
    _createVNode(_component_v_card, {
      class: "pa-3 mb-2",
      variant: "outlined"
    }, {
      default: _withCtx(() => [
        (resultados.value.length === 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_20, " Aún no tiene resultados en eventos. "))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultadosVisibles.value, (resultado) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `${resultado.idTorneo}-${resultado.nombreTorneo}`,
                  class: "d-flex align-center ga-2 mb-1"
                }, [
                  _createVNode(_component_v_icon, {
                    size: "small",
                    icon: resultado.resultado <= 3 ? 'mdi-trophy' : 'mdi-flag-checkered',
                    color: colorPuesto(resultado.resultado)
                  }, null, 8, ["icon", "color"]),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(resultado.nombreTorneo), 1),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(textoPosicion)(resultado.resultado, resultado.totalJugadores)), 1)
                ]))
              }), 128)),
              (resultados.value.length > 3)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    variant: "text",
                    size: "small",
                    class: "mt-1 px-0",
                    "append-icon": verTodosResultados.value ? 'mdi-chevron-up' : 'mdi-chevron-down',
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (verTodosResultados.value = !verTodosResultados.value))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(verTodosResultados.value
              ? "Ver solo los tres mejores"
              : `Ver ${resultados.value.length - 3 === 1 ? "el otro" : `los otros ${resultados.value.length - 3}`}`), 1)
                    ]),
                    _: 1
                  }, 8, ["append-icon"]))
                : _createCommentVNode("", true)
            ], 64))
      ]),
      _: 1
    }),
    (caraACara.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("h2", _hoisted_23, "Tú contra " + _toDisplayString(_ctx.usuario.nick), 1),
          _createVNode(_component_v_card, {
            class: "pa-3 mb-2",
            variant: "outlined"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_chip_group, {
                modelValue: origenCara.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((origenCara).value = $event)),
                mandatory: "",
                column: "",
                "selected-class": "text-primary",
                class: "mb-1"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ORIGENES, (o) => {
                    return _createVNode(_component_v_chip, {
                      key: o.valor,
                      value: o.valor,
                      size: "small",
                      filter: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(o.titulo), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (caraACara.value.balance.total === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(origenCara.value === "todas"
              ? "Aún no habéis jugado ninguna partida."
              : origenCara.value === "torneo"
                ? "Aún no habéis jugado en ningún evento."
                : "Aún no habéis jugado ninguna amistosa."), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_26, _toDisplayString(caraACara.value.balance.victorias), 1),
                        _hoisted_27
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_28, _toDisplayString(caraACara.value.balance.empates), 1),
                        _hoisted_29
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_30, _toDisplayString(caraACara.value.balance.derrotas), 1),
                        _hoisted_31
                      ])
                    ]),
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      size: "small",
                      class: "mt-1 px-0",
                      "append-icon": verPartidasCara.value ? 'mdi-chevron-up' : 'mdi-chevron-down',
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (verPartidasCara.value = !verPartidasCara.value))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(verPartidasCara.value ? "Ocultar las partidas" : `Ver ${caraACara.value.partidas.length === 1 ? "la partida" : `las ${caraACara.value.partidas.length} partidas`}`), 1)
                      ]),
                      _: 1
                    }, 8, ["append-icon"]),
                    _createVNode(_component_v_expand_transition, null, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(caraACara.value.partidas, (partida) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: partida.clave,
                              class: "partida-cara py-2"
                            }, [
                              _createElementVNode("div", _hoisted_32, [
                                _createVNode(_component_v_chip, {
                                  size: "x-small",
                                  label: "",
                                  color: colorResultado(partida.resultado)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(partida.resultado), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["color"]),
                                _createElementVNode("span", _hoisted_33, " Tú " + _toDisplayString(partida.rival) + " - " + _toDisplayString(partida.propios) + " " + _toDisplayString(_ctx.usuario.nick), 1),
                                _createElementVNode("span", _hoisted_34, _toDisplayString(fecha(partida.fecha)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_35, _toDisplayString(partida.evento ?? "Amistosa"), 1),
                              (partida.ejercito || partida.ejercitoRival)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(partida.ejercitoRival ?? "—") + " contra " + _toDisplayString(partida.ejercito ?? "—"), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ], 512), [
                          [_vShow, verPartidasCara.value]
                        ])
                      ]),
                      _: 1
                    })
                  ], 64))
            ]),
            _: 1
          })
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})